import { UrlQueryKey } from '@/core/urlQueryKey';

export const BrandProductGuideIframeUpdatedEventType = 'brandProductGuideIframeUpdated';
export const BrandProductGuideIframeCloseEventType = 'brandProductGuideIframeClose';
export const BrandProductGuideIframeGoToBrandSelectorEventType = 'brandProductGuideIframeGoToBrandSelector';
export class BrandProductGuideIframeUpdatedEvent extends CustomEvent<BrandProductGuideIframeUpdatedEventDetail> {
    constructor(detail: BrandProductGuideIframeUpdatedEventDetail) {
        super(BrandProductGuideIframeUpdatedEventType, { detail });
    }
}
export interface BrandProductGuideIframeUpdatedEventDetail extends CustomEvent {
    detail: {
        guide: {
            productGuideUrl: string;
            [UrlQueryKey.productGuideBrandName]: string;
            [UrlQueryKey.productGuideId]: string;
            [UrlQueryKey.productGuideKey]: string;
            [UrlQueryKey.productGuideSearchKey]?: string
        };
        brandName: string;
    };
}
